export const makeCurrency = (amount, ds = true) => {
    // return "$" + amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return `${ds ? "$" : ""} ${amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
  };